import { ContentTypes } from './types';

export default function HeaderRightSideBar({
  className,
  children,
}: ContentTypes): React.JSX.Element {
  return <div className={`header-sidebar ${className || ''}`}>{children}</div>;
}
